import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PortalLayout({ children }: { children: React.ReactNode }) {
  const { logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: '/ops', label: 'Live Ops' },
    { path: '/health', label: 'System Health' },
    { path: '/targets', label: 'Targets' },
    { path: '/jobs', label: 'Sync Jobs' },
  ];

  return (
    <div>
      <nav style={{
        background: 'linear-gradient(135deg, #1B3A5C 0%, #245080 100%)',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '56px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: '16px' }}>
            Niche Data
          </span>
          <div style={{ display: 'flex', gap: '4px' }}>
            {navItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  color: location.pathname === item.path ? '#fff' : 'rgba(255,255,255,0.65)',
                  textDecoration: 'none',
                  padding: '8px 14px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 500,
                  background: location.pathname === item.path ? 'rgba(255,255,255,0.12)' : 'transparent',
                  transition: 'all 0.15s',
                }}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
        <button
          onClick={logout}
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.2)',
            color: 'rgba(255,255,255,0.8)',
            padding: '6px 14px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '13px',
          }}
        >
          Logout
        </button>
      </nav>
      <main style={{ maxWidth: '1280px', margin: '0 auto', padding: '24px' }}>
        {children}
      </main>
    </div>
  );
}
